import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button} from '../../../../_gori/partials/widgets'
import {
  BranchesMenu,
  DEFAULT_BRANCHES_MENU,
  getSelectedAccountIds,
} from '../components/BranchesMenu'
import type {BranchesMenuData} from '../core/_types'

type Props = {
  show: boolean
  handleClose: () => void
  onApply?: (menuData: BranchesMenuData, selectedAccountIds: Array<string | number>) => void
  initialMenuData?: BranchesMenuData
  initialBranches?: BranchesMenuData
}

const cloneMenuData = (menuData: BranchesMenuData): BranchesMenuData => ({
  branches: menuData.branches.map((branch) => ({
    ...branch,
    accounts: branch.accounts.map((account) => ({...account})),
  })),
  unassignedAccounts: menuData.unassignedAccounts.map((account) => ({...account})),
})

const BranchesMenuModal: FC<Props> = ({
  show,
  handleClose,
  onApply,
  initialMenuData,
  initialBranches,
}) => {
  const intl = useIntl()
  const resolvedInitialMenuData = initialMenuData ?? initialBranches
  const [draftMenuData, setDraftMenuData] = useState<BranchesMenuData>(DEFAULT_BRANCHES_MENU)
  const [appliedMenuData, setAppliedMenuData] = useState<BranchesMenuData>(DEFAULT_BRANCHES_MENU)

  useEffect(() => {
    if (!show) {
      return
    }
    setDraftMenuData(cloneMenuData(resolvedInitialMenuData ?? appliedMenuData))
  }, [appliedMenuData, resolvedInitialMenuData, show])

  const handleCloseModal = () => {
    handleClose()
  }

  const handleCancel = () => {
    setDraftMenuData(cloneMenuData(resolvedInitialMenuData ?? appliedMenuData))
    handleCloseModal()
  }

  const handleApply = () => {
    const nextMenuData = cloneMenuData(draftMenuData)
    setAppliedMenuData(nextMenuData)
    onApply?.(nextMenuData, getSelectedAccountIds(nextMenuData))
    handleCloseModal()
  }

  return (
    <Modal
      id='gori_modal_branches_menu'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-size-md branches-menu-modal'
      contentClassName='modal-padding branches-menu-modal__content'
      show={show}
      backdrop='static'
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton className='branches-menu-modal__header'>
        <Modal.Title bsPrefix='fw-bolder fs-1 modal-title'>
          {intl.formatMessage({id: 'ACCOUNTS'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='branches-menu-modal__body p-0'>
        <BranchesMenu
          menuData={draftMenuData}
          onMenuDataChange={setDraftMenuData}
          showTitle={false}
          className='branches-menu--modal'
        />
      </Modal.Body>
      <Modal.Footer className='branches-menu-modal__footer'>
        <div className='d-flex w-100 gap-3'>
          <Button
            classNameDiv='w-50'
            className='btn btn-advanced-secondary flex-fill w-100'
            label={intl.formatMessage({id: 'CANCEL'})}
            loadingText={intl.formatMessage({id: 'CANCEL'})}
            event={handleCancel}
          />
          <Button
            classNameDiv='w-50'
            className='btn btn-advanced-primary flex-fill w-100'
            label={intl.formatMessage({id: 'APPLY'})}
            loadingText={intl.formatMessage({id: 'APPLY'})}
            event={handleApply}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export {BranchesMenuModal}
